import { useMemo } from 'react'
import { useTheme } from '@mui/material'
import { DomainOutlined, LockOutlined, PublicOutlined } from '@mui/icons-material'
import { CommonPrivacy } from 'features/common/types'
import RoundedIcon, { RoundedIconProps } from '../RoundedIcon'

const PrivacyIcon = ({
  privacy,
  size = 'small',
  border,
  ...otherProps
}: { privacy: CommonPrivacy } & Partial<RoundedIconProps>) => {
  const theme = useTheme()
  const roundedIconProps = useMemo(() => {
    switch (privacy) {
      case CommonPrivacy.Shared:
        return {
          icon: <DomainOutlined />,
          iconColor: theme.palette.secondary.dark,
          backgroundColor: theme.palette.secondary.relatedLight
        }
      case CommonPrivacy.Public:
        return {
          icon: <PublicOutlined />,
          iconColor: theme.palette.primary.dark,
          backgroundColor: theme.palette.primary.relatedLight
        }
      case CommonPrivacy.Private:
      default:
        return {
          icon: <LockOutlined />,
          iconColor: theme.palette.common.black,
          backgroundColor: theme.palette.default.main
        }
    }
  }, [privacy, theme])
  return <RoundedIcon size={size} border={border} {...roundedIconProps} {...otherProps} />
}
export default PrivacyIcon
